import { connect } from 'react-redux';

import memoize from 'lodash/memoize';

import { withOverlayControls } from '@eb/eds-structure';
import {
    LocationAutocomplete,
    getLocationSuggestions,
} from '@eb/destination-utils';

import {
    searchLocationSuggestions as searchLocationSuggestionsAction,
    getUserCurrentLocation as getUserCurrentLocationAction,
    locationChange as locationChangeAction,
} from '../redux/location/actions';

const getLocationSuggestionsMemoized = memoize(getLocationSuggestions);

const _mapStateToProps = (state) => ({
    currentPlace: state.location.currentPlace,
    currentPlaceParent: state.location.currentPlaceParent,
    isUsingCurrentLocation: state.location.isUsingCurrentLocation,
    isUseCurrentLocationEnabled:
        state.app.featureFlags.useCurrentLocation &&
        !state.location.locationDenied,
    isOnline: state.location.isOnline,
    isWaitingForLocation: state.location.isWaitingForLocation,
    locationSuggestions: getLocationSuggestionsMemoized(
        state.location,
        state.app.featureFlags.useCurrentLocation &&
            !state.location.locationDenied,
    ),
    latitude: state.location.latitude,
    longitude: state.location.longitude,
    placeId: state.location.placeId,
});

const _mapDispatchToProps = {
    handleLocationSuggestionChange: searchLocationSuggestionsAction,
    handleLocationSelect: locationChangeAction,
    handleUseCurrentLocation: getUserCurrentLocationAction,
};

export default withOverlayControls(
    connect(_mapStateToProps, _mapDispatchToProps)(LocationAutocomplete),
);
